import React from 'react'
import type { MenuProps as MuiMenuProps } from '@material-ui/core/Menu'
import MuiMenu from '@material-ui/core/Menu'

export type MenuProps = MuiMenuProps

const Menu = React.forwardRef<HTMLDivElement, MenuProps>(function Menu(props, ref) {
  return <MuiMenu ref={ref} {...props} />
})

export default Menu
